
export default {
  NETWORK_TIMEOUT: (40) * 1000,
  POLL_DURATION: 10 * 1000, // poll every x sec after timeout

  SCAN_TIMEOUT_DEFAULT: (40 + 10) * 1000,
  SCAN_TIMEOUT_1: (40 + 20 + 20 + 20) * 1000,
  SCAN_TIMEOUT_MAX: (40 + 20 + 20 + 20 + 10) * 1000,

  POLL_EXTEND_DEFAULT: 10 * 1000,
  POLL_EXTEND_1: (20 + 20 + 20) * 1000,
  POLL_EXTEND_MAX: (20 + 20 + 20 + 10) * 1000,

};
